import { useEffect, useState } from "react";

import { useInterval } from "hooks/use_interval";
import { decodeFlightAuthToken } from "utils/auth";
import { getAuthToken } from "utils/cookie";

const TOKEN_POLLING_INTERVAL = 30 * 1000;

// If a user logs out of Forum in another tab while in a FLIGHT class and then logs back in,
// their auth token and csrf token will be updated. FLIGHT needs to know about this, otherwise
// the user will get 403 errors when trying to make requests to the Forum server due to using
// an outdated csrf token. Hence, we poll for the auth token and update the csrftoken cookie
// if it changes so that future API requests will succeed.
function AuthTokenPollerTask() {
  const _flightAuthToken = getAuthToken();
  const [flightAuthToken, setFlightAuthToken] = useState<string>(_flightAuthToken);

  useInterval(
    () => {
      const token = getAuthToken();
      setFlightAuthToken(token);
    },
    TOKEN_POLLING_INTERVAL,
    true,
  );

  useEffect(() => {
    if (flightAuthToken) {
      window.flightLogger.log("[AuthTokenPollerTask] Decoding auth token");
      decodeFlightAuthToken(flightAuthToken);
    }
  }, [flightAuthToken]);

  return null;
}

export { AuthTokenPollerTask };
